export const browserUtils = {
    reloadPage: (): void => {
        window.location.reload();
    },
};
